import { render, staticRenderFns } from "./FormVideoCall.vue?vue&type=template&id=5609b334&"
import script from "./FormVideoCall.vue?vue&type=script&lang=js&"
export * from "./FormVideoCall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports